import React from 'react';

const PrivacyPolicySinhala = () => {
    return (
        <>
            <div className="container">
                <h1>රහස්‍යතා ප්‍රතිපත්තිය</h1>
                <p><strong>ප්‍රභාෂක දිනය:</strong> 2025 මැයි 30</p>
                <p>
                Boggler (Private) Limited (“<strong>Boggler</strong>”, “<strong>අපි</strong>”, “<strong>අපගේ</strong>” හෝ “<strong>අප</strong>”) ඔබේ රහස්‍යතාවයට අගය කරයි. ඔබ පහත සඳහන් සේවාවන් භාවිතා කරන විට ඔබේ තොරතුරු කොපමණ ලෙස රැස් කරන්නේ, භාවිතා කරනේ, බෙදා ගන්නේ සහ ආරක්ෂා කරනේද යන්න මෙය විස්තර කරයි:
                </p>
                <ul>
                <li>theboggler.com වෙබ් අඩවිය (“<strong>වෙබ්අඩවිය</strong>”)</li>
                <li>ජංගම යෙදුම් — <strong>Buckish</strong>, <strong>Apex</strong>, සහ <strong>Third View</strong> — (එකතුව “<strong>යෙදුම</strong>” හෝ “<strong>යෙදුම්</strong>”)</li>
                </ul>
                <p>ඔබ අපගේ වෙබ්අඩවිය හෝ යෙදුම් භාවිතා කිරීමෙන්, මෙම රහස්‍යතා ප්‍රතිපත්තිය පිළිගනිමින් එකඟ වීමට හැඳින්වේ.</p>

                <h2>1. අපි රැස් කරන තොරතුරු</h2>
                <h3>a. ඔබ ලබා දෙන තොරතුරු</h3>
                <ul>
                <li><strong>ස්ක්‍රීන්ෂොට් සහ අන්තර්ගතය:</strong> ආරක්ෂිතව ගබඩා කර ඔබ තෝරාගත් මගපෙන්වන්නන්ට පමණක් ලබා දේ.</li>
                <li><strong>ගිණුම් සහ ගෙවීම් තොරතුරු:</strong> ඔබේ ඊමේල්, ගෙවීම් විස්තර සහ ගනුදෙනු ඉතිහාසය. ගෙවීම් තුන්වන පාර්ශව සේවා (උදා: Stripe, Apple Pay) හරහා සකසයි.</li>
                <li><strong>පැතිකඩ ප්‍රමුඛතා:</strong> මගපෙන්වන්නන් තේරීම, මානසික තත්ත්වය, සහ අමතර තොරතුරු.</li>
                </ul>
                <h3>b. ස්වයංක්‍රීයව රැස් කරන තොරතුරු</h3>
                <ul>
                <li><strong>උපාංග දත්ත:</strong> උපාංග වර්ගය, මෙහෙයුම් පද්ධතිය, බ්‍රව්සරය, යෙදුම් අනුවාදය.</li>
                <li><strong>භාවිතා දත්ත:</strong> යෙදුම භාවිතා කළ කාලය, ක්‍රියාකාරකම්, යොමු දත්ත.</li>
                </ul>

                <h2>2. ඔබේ තොරතුරු අපි භාවිතා කරන ආකාරය</h2>
                <ul>
                <li>වෙබ්අඩවිය සහ යෙදුම් ලබා දීමට සහ වර්ධනය කිරීමට</li>
                <li>උඩුගත කළ දේ ඔබ තෝරාගත් මගපෙන්වන්නන්ට සම්බන්ධ කිරීමට</li>
                <li>දායකතා සහ ගෙවීම් පහසු කිරීමට</li>
                <li>භාවිතා රටා විශ්ලේෂණය කර සේවාවන් වැඩි දියුණු කිරීමට</li>
                <li>ගිණුම් යාවත්කාලීන කිරීම් සහ සහය සඳහා සන්නිවේදනය කිරීමට</li>
                </ul>

                <h2>3. ඔබේ තොරතුරු අපි බෙදාගන්නේ කෙසේද</h2>
                <p>අපි ඔබේ දත්ත <strong>විකුණන්නේ නැත</strong>. අපි පහත සමඟ බෙදා ගනු ඇත:</p>
                <ul>
                <li><strong>මගපෙන්වන්නන්:</strong> ඔබ තෝරාගත් අය පමණක්.</li>
                <li><strong>ගෙවීම් සැකසුම් සේවාවන්:</strong> ගනුදෙනු සැලසුම් සඳහා.</li>
                <li><strong>සේවා සැපයුම්කරුවන්:</strong> විශ්ලේෂණය, ගබඩා කිරීම සහ ආරක්ෂාව සඳහා.</li>
                <li><strong>නීතිමය අධිකාරීන්:</strong> නීතිමය අවශ්‍යතා මත.</li>
                </ul>

                <h2>4. දත්ත ආරක්ෂාව</h2>
                <p>අපි සම්මත ගුප්තකේතන සහ ප්‍රවේශ පාලන ක්‍රම ක්‍රියාත්මක කරයි. එහෙත්, කිසිදු ක්‍රමය 100% ආරක්ෂිත නොවන බැවින්, සංවේදී තොරතුරු බෙදා ගැනීමේදී සතපට්ට වන්න.</p>

                <h2>5. ඔබේ අයිතිවාසිකම් සහ තේරීම්</h2>
                <ul>
                <li><strong>ප්‍රවේශය හෝ මකා දැමීම:</strong> <span onClick={() => window.open("mailto:buck@theboggler.com")}>buck@theboggler.com</span> වෙත ඊමේල් කරන්න.</li>
                <li><strong>අලෙවි විකාශන ඉවත් වීම:</strong> ඕනෑම වෙලාවේ ඉවත් විය හැක.</li>
                <li><strong>දත්ත රැගෙන යාම:</strong> විමසීමක් මත, සත්‍ය තහවුරු කිරීමෙන් පසු ලබා ගත හැක.</li>
                </ul>

                <h2>6. ළමුන්ගේ රහස්‍යතාව</h2>
                <p>අපගේ සේවාවන් අවුරුදු 13 ට අඩු ළමුන් සඳහා නොයෙදුණි. දත්ත රැස් කර ඇති බව තහවුරු වූ විට, එය කඩිනමින් මකා දැමේ.</p>

                <h2>7. ජාත්‍යන්තර පරිශීලකයින්</h2>
                <p>ඔබේ දත්ත USA, ශ්‍රී ලංකාව හෝ වෙනත් රටවල් වල, විවිධ දත්ත ආරක්ෂා නීති මත සකස් විය හැක.</p>

                <h2>8. තෙවන පාර්ශව සබැඳි</h2>
                <p>වෙබ්අඩවිය සහ යෙදුම් තුළ ඇති තෙවන පාර්ශව සබැඳි වල රහස්‍යතා ක්‍රමවලට අපි වගකීමක් නොගනී.</p>

                <h2>9. ප්‍රතිපත්ති වෙනස්කම්</h2>
                <p>අපි කලින් කලින් මෙම ප්‍රතිපත්තිය යාවත්කාලීන කරනු ඇත. යාවත්කාලීන කිරීමේ දිනය "ප්‍රභාෂක දිනය" මගින් දක්වනු ලැබේ. නීතිමය අවශ්‍යතා මත ඔබට දැනුම් දෙනු ඇත.</p>

                <h2>10. අප අමතන්න</h2>
                <p>
                <strong>Boggler (Private) Limited</strong><br />
                272b 2/1 High Level Road<br />
                Maharagama 10280, ශ්‍රී ලංකාව<br />
                ඊමේල්: <span onClick={() => window.open("mailto:buck@theboggler.com")}>buck@theboggler.com</span>
                </p>
            </div>
        </>
    );
}

export default PrivacyPolicySinhala;